import React from 'react';
import { useOutletContext } from "react-router-dom";

import { default as ResponseEndpoint } from '../Models/Response/EndPoint';
import { default as ResponseTwopoint } from '../Models/Response/TwoPoint';
import { default as ResponseNpoint } from '../Models/Response/NPoint';
import { default as ResponseImmunoRate } from '../Models/Response/ImmunoRate';
import { default as ResponseDualWavelength } from '../Models/Response/DualWavelength';
import { default as ResponseDualWavelengthBlank } from '../Models/Response/DualWavelengthBlank';
import { default as ResponsePotentiometric } from '../Models/Response/Potentiometric';

import { default as CalibrationEndpoint } from '../Models/Calibration/EndPoint';
import { default as CalibrationTwoPoint } from '../Models/Calibration/TwoPoint';
import { default as CalibrationNPoint } from '../Models/Calibration/NPoint';
import { default as CalibrationImmunoRate } from '../Models/Calibration/ImmunoRate';
import { default as CalibrationDualWavelength } from '../Models/Calibration/DualWavelength';
import { default as CalibrationDualWavelengthBlank } from '../Models/Calibration/DualWavelengthBlank';
import { default as CalibrationPotentiometric } from '../Models/Calibration/Potentiometric';

import { default as PredictionEndpoint } from '../Models/Prediction/EndPoint';
import { default as PredictionTwoPoint } from '../Models/Prediction/TwoPoint';
import { default as PredictionNPoint } from '../Models/Prediction/NPoint';
import { default as PredictionImmunoRate } from '../Models/Prediction/ImmunoRate';
import { default as PredictionDualWavelength } from '../Models/Prediction/DualWavelength';
import { default as PredictionDualWavelengthBlank } from '../Models/Prediction/DualWavelengthBlank';
import { default as PredictionPotentiometric } from '../Models/Prediction/Potentiometric';

import { default as UtilitySplineInterpolate } from '../Models/Utility/SplineInterpolate';

const Lvcc = () => {
    const { selection } = useOutletContext();
    const { calculation, model } = selection;

    return (
        <div>
            {!model && (
                <p style={{ textAlign: 'center', marginTop: '100px', fontSize: '18px' }}>
                    Select a model from the Calculation Model dropdown
                </p>
            )}

            {calculation === 'Response' && model === 'End Point' && <ResponseEndpoint />}
            {calculation === 'Response' && model === 'Two Point' && <ResponseTwopoint />}
            {calculation === 'Response' && model === 'N Point' && <ResponseNpoint />}
            {calculation === 'Response' && model === 'ImmunoRate' && <ResponseImmunoRate />}
            {calculation === 'Response' && model === 'Dual Wavelength' && <ResponseDualWavelength />}
            {calculation === 'Response' && model === 'DW Blank' && <ResponseDualWavelengthBlank />}
            {calculation === 'Response' && model === 'Potentiometric' && <ResponsePotentiometric />}

            {calculation === 'Calibration' && model === 'End Point' && <CalibrationEndpoint />}
            {calculation === 'Calibration' && model === 'Two Point' && <CalibrationTwoPoint />}
            {calculation === 'Calibration' && model === 'N Point' && <CalibrationNPoint />}
            {calculation === 'Calibration' && model === 'ImmunoRate' && <CalibrationImmunoRate />}
            {calculation === 'Calibration' && model === 'Dual Wavelength' && <CalibrationDualWavelength />}
            {calculation === 'Calibration' && model === 'DW Blank' && <CalibrationDualWavelengthBlank />}
            {calculation === 'Calibration' && model === 'Potentiometric' && <CalibrationPotentiometric />}
            
            {calculation === 'Prediction' && model === 'End Point' && <PredictionEndpoint />}
            {calculation === 'Prediction' && model === 'Two Point' && <PredictionTwoPoint />}
            {calculation === 'Prediction' && model === 'N Point' && <PredictionNPoint />}
            {calculation === 'Prediction' && model === 'ImmunoRate' && <PredictionImmunoRate />}
            {calculation === 'Prediction' && model === 'Dual Wavelength' && <PredictionDualWavelength />}
            {calculation === 'Prediction' && model === 'DW Blank' && <PredictionDualWavelengthBlank />}
            {calculation === 'Prediction' && model === 'Potentiometric' && <PredictionPotentiometric />}

            {calculation === 'Utility' && model === 'Spline Interpolate' && <UtilitySplineInterpolate />}

        </div>
    );
};

export default Lvcc;